import { render, staticRenderFns } from "./TogglePenControl.vue?vue&type=template&id=0778c885&scoped=true&lang=pug&"
import script from "./TogglePenControl.vue?vue&type=script&lang=ts&"
export * from "./TogglePenControl.vue?vue&type=script&lang=ts&"
import style0 from "./TogglePenControl.vue?vue&type=style&index=0&id=0778c885&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0778c885",
  null
  
)

export default component.exports